const STORAGE_KEY = 'caju-expected-lead-id';
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

interface StoredEntry {
  id: string;
  expiresAt: number;
}

export function getStoredExpectedLeadId(): string {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return '';
    const entry: StoredEntry = JSON.parse(raw);
    if (Date.now() > entry.expiresAt) {
      localStorage.removeItem(STORAGE_KEY);
      return '';
    }
    return entry.id;
  } catch {
    return '';
  }
}

export function storeExpectedLeadId(id: string): void {
  try {
    const entry: StoredEntry = { id, expiresAt: Date.now() + ONE_WEEK_MS };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
  } catch {
    // localStorage indisponível
  }
}
